module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/order-groups/single-order-group/single-order-group-details/single-order-group-details.component.css
// module id = ./src/app/order-groups/single-order-group/single-order-group-details/single-order-group-details.component.css
// module chunks = main